class ScrollSpyNav extends HTMLElement {
  constructor() {
    super();
    this.smallScreen = false;
    this.resizeObserver = new ResizeObserver(this.setSizing.bind(this)).observe(document.body);
  }

  setSizing() {
    if (window.innerWidth > 750) {
      this.stickyHeaderHeight = 170;
      this.smallScreen = false;
    } else {
      this.stickyHeaderHeight = 90;
      this.smallScreen = true;
    }
  }

  connectedCallback() {
    this.nav = this;
    this.scrollSpyContainer = document.querySelector('[data-scroll-spy-container]');
    this.currentScrollTop = 0;
    this.currentHeight = this.offsetHeight;
    this.smoothScrollNavLinks();
    this.scrollSpySections = this.scrollSpyContainer.querySelectorAll('[data-scroll-spy-section]');
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    for (let i = 0; i < this.scrollSpySections.length; i++) {
      const section = this.scrollSpySections[i];

      if (!section || !section.getBoundingClientRect) {
        return;
      }

      const boundingRect = section.getBoundingClientRect();
      const topOfElement = boundingRect.top + window.scrollY - this.currentHeight - this.stickyHeaderHeight;
      const activeLinks = this.nav.querySelectorAll('[data-scroll-spy-active]');

      if (topOfElement <= scrollTop && this.currentSection !== section) {
        this.currentSection = section;
        const id = section.id;
        activeLinks.forEach((activeLink) => {
          delete activeLink.dataset.scrollSpyActive;
        });

        if (!id) {
          return;
        }

        const activeItem = this.nav.querySelector(`a[href*=${id}]`);
        if (activeItem) {
          activeItem.dataset.scrollSpyActive = 'true';
          this.nav.closest('[data-scroll-spy-overflow-container]').scrollTo({
            top: 0,
            left: activeItem.offsetLeft - 20,
            behavior: 'smooth'
          });
        }
      } else if (i === 0 && this.currentSection !== null && scrollTop < topOfElement) {
        // If this is the first section, and scroll is above it, set
        // current section to nothing, and reset the active nav links.
        this.currentSection = null;
        activeLinks.forEach((activeLink) => {
          delete activeLink.dataset.scrollSpyActive;
        });
      }
    }

    this.currentScrollTop = scrollTop;
  }

  smoothScrollNavLinks() {
    const navLinks = this.querySelectorAll('a');
    for (let link in navLinks) {
      if (navLinks.hasOwnProperty(link)) {
        navLinks[link].addEventListener('click', (event) => {
          event.preventDefault();
          const section = this.scrollSpyContainer.querySelector(navLinks[link].hash);
          const boundingRect = section.getBoundingClientRect();
          const topOfElement = boundingRect.top  + window.scrollY - this.stickyHeaderHeight;
          window.scroll({ top: topOfElement, behavior: "smooth" });
        });
      }
    }
  }
}

customElements.define('scroll-spy-nav', ScrollSpyNav);